import { useNewsletterMethod } from "@made-people/grease-newsletter";
import { orderEventEmitter, OrderEvents } from "@made-people/grease-order";
import { useEffect } from "react";

export const NEWSLETTER_SIGNUP_KEY = "mm-checkout-newsletter-signup";

export const MMNewsletterOrderListener = () => {
  const { execute } = useNewsletterMethod("subscribe");

  useEffect(() => {
    const handleOrderPlaced = (event: OrderEvents["orderPlaced"]) => {
      const shouldSignup = sessionStorage.getItem(NEWSLETTER_SIGNUP_KEY);

      if (shouldSignup === "true" && event.order?.shippingAddress?.email) {
        execute({
          email: event.order.shippingAddress?.email,
          attributes: {
            firstName: event.order.shippingAddress?.firstName,
            lastName: event.order.shippingAddress?.lastName,
            phoneNumber: event.order.shippingAddress?.phoneNumber,
          },
        })
          .then(() => {
            sessionStorage.removeItem(NEWSLETTER_SIGNUP_KEY);
          })
          .catch((error) => {
            console.error("Newsletter subscription failed:", error);
          });
      }
    };

    orderEventEmitter.on("orderPlaced", handleOrderPlaced);
    return () => {
      orderEventEmitter.off("orderPlaced", handleOrderPlaced);
    };
  }, [execute]);

  return null;
};
